import { WEB_URL } from "@/config/endpoints";

export function glossaryBreadcrumbSchema({
  glossaryURL,
  glossaryTitle,
  homeUrl,
}) {
  const baseGlossaryUrl = `${WEB_URL}/finance-glossary`;
  const glossaryPageUrl = glossaryURL
    ? `${WEB_URL}/finance-glossary/${glossaryURL}`
    : null;

  const itemList = [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: homeUrl,
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "Finance Glossary",
      item: baseGlossaryUrl,
    },
  ];

  if (glossaryURL) {
    itemList.push({
      "@type": "ListItem",
      position: 3,
      name: glossaryTitle,
      item: glossaryPageUrl,
    });
  }

  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: itemList,
  };
}